var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClearbit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.273 0h7.454c1.486 0 2.025.155 2.568.445.543.29.97.717 1.26 1.26.29.543.445 1.082.445 2.568v7.454c0 1.486-.155 2.025-.445 2.568-.29.543-.717.97-1.26 1.26-.543.29-1.082.445-2.568.445H4.273c-1.486 0-2.025-.155-2.568-.445a3.029 3.029 0 01-1.26-1.26C.155 13.752 0 13.213 0 11.727V4.273c0-1.486.155-2.025.445-2.568.29-.543.717-.97 1.26-1.26C2.248.155 2.787 0 4.273 0z",
    id: "Clearbit_svg__[object_Object]a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Clearbit_svg__[object_Object]b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Clearbit_svg__[object_Object]a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#148CFC",
    xlinkHref: "#Clearbit_svg__[object_Object]a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DB1FD",
    mask: "url(#Clearbit_svg__[object_Object]b)",
    d: "M8 0h8v16H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2FAFE",
    mask: "url(#Clearbit_svg__[object_Object]b)",
    d: "M8 8h8v8H8z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearbit);
export default ForwardRef;